import { render, staticRenderFns } from "./OrderBusiness.vue?vue&type=template&id=755a0898"
import script from "./OrderBusiness.vue?vue&type=script&lang=js"
export * from "./OrderBusiness.vue?vue&type=script&lang=js"
import style0 from "./OrderBusiness.vue?vue&type=style&index=0&id=755a0898&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports